import React from 'react';
import { Navigate } from 'react-router-dom';
import moment from 'moment';
import _ from 'lodash';
import queryString from 'query-string';
import Navigation from '../_components/Navigation';
import AccountDropdown from '../_components/AccountDropdown';
import "@progress/kendo-theme-bootstrap/dist/all.css";
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { userService } from 'Services';
import { withAuthenticatedUser } from 'Components/withAuthenticatedUser';
import styles from './InvoicePage.module.css';

class DateTimeCell extends React.Component {
    render() {
        const value = this.props.dataItem[this.props.field];            
        return (
            <td colSpan="1">{moment(value).format("DD/MM/YYYY")}</td>
        );
    }
}

class InvoiceLinkCell extends React.Component {
    onInvoiceLinkClick = (invoiceID,invoiceNo,event) => {
        event.preventDefault();
        this.setState({ hasUrl:"loading" });
        userService.getInvoice(invoiceID)
        .then(url => {
            this.setState({hasUrl:"no"});
            var fileLink = document.createElement('a');
            document.body.appendChild(fileLink);
            fileLink.href = url;
            fileLink.download = "invoice_" + invoiceNo + ".pdf";
            fileLink.click();   
            window.URL.revokeObjectURL(url);
        });
    }
    
    constructor(props) {
        super(props);
        this.state = {
            hasUrl: "no",
            url:null
        }
    }
    
    render() {
        const value = this.props.dataItem["id"];
        const invoiceNo = this.props.dataItem["number"];
        return (
            <td colSpan="1">
                <a disabled={this.state.hasUrl=="loading"} href="#" onClick={this.onInvoiceLinkClick.bind(this,value,invoiceNo)}>{invoiceNo}</a>
            </td>
        );
    }
}

class InvoicePage extends React.Component {
    handleAccountChange(event) {
        var account = event.target.value;
        this.setState({
            account: account,
            dataState: { take: 10, skip: 0, sort: this.state.dataState.sort } /* partial reset */
        }, function() {
            this.fetchData(this.state.dataState)
        });
    }  
    
    fetchData(dataState) {
        var that = this;
        this.setState({ loading: true });
        userService.getInvoices(this.state.account, dataState)
        .then(invoices => {
            that.setState({
                invoices,
                loading: false
            });
        })
        .catch(error => {
            this.setState({
                invoices: { data: [], total: 0 },
                loading: false
            });
        });
    }
    
    handleDataStateChange = (changeEvent) => {
        this.setState({ dataState: changeEvent.data });
        this.fetchData(changeEvent.data);
    }
    
    constructor(props) {
        super(props);
        this.handleAccountChange = this.handleAccountChange.bind(this);
        this.fetchData = this.fetchData.bind(this);
   
        var state = {
            account: "dummy",
            invoices: { data: [], total: 0 },
            dataState: { take: 10, skip: 0, sort: [] }
        };

        if (props.authenticatedUser) {
            Object.assign(state, {
                account: props.authenticatedUser.default_account
            });
        }

        this.state = state;
    }
    
    componentDidMount() {
        this.fetchData(this.state.dataState);
    }
    
    DateTimeCell = (props) => <DateTimeCell {...props} />
    InvoiceLinkCell = (props) => <InvoiceLinkCell {...props} />
    
    render() {
        
        var privileges = null;
        

        if (this.props.authenticatedUser) {
            privileges = this.props.authenticatedUser.privileges;
        }

        
        var canViewInvoices = privileges && _.some(privileges, ['description', 'Invoices']);

        if (!canViewInvoices)
            return <Navigate to="/Welcome" />
        

        var _ds = this.state.dataState;
        return (
            <div id="invoices">
                <Navigation active="invoices" authenticatedUser={this.props.authenticatedUser} />
                <div className="container-fluid padding-lr55 bg-form">
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="row h3">
                                <div className="col-xs-12">Invoice List</div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                            <span className="labeltext">Deadline Account:</span>
                            <AccountDropdown
                                className="form-control margin-tb10"
                                id="account"
                                authenticatedUser={this.props.authenticatedUser}
                                name="account"
                                value={this.state.account}
                                onChange={this.handleAccountChange}
                                disabled={_.loading} />
                            {this.state.loading &&
                                <span className="glyphicon glyphicon-refresh glyphicon-spin padding-lr10 text250"/>
                            }
                        </div>
                    </div>
                    <div className="padding-tb10" />
                </div>

                <div className="padding-tb10" />

                <div className="container-fluid padding-lr55">
                    <div className="row">
                        <div className="col-xs-12">
                            <div id="invoiceQueryResult" styleName="styles.grid">
                                <Grid
                                    filterable={false}
                                    sortable={true}
                                    pageable={{ pageSizes: true }}
                                    data={this.state.invoices.data}
                                    total={this.state.invoices.total}
                                    skip={_ds.skip}
                                    pageSize={_ds.take}
                                    filter={_ds.filter}
                                    sort={_ds.sort}
                                    onDataStateChange={this.handleDataStateChange}
                                    onFetchData={this.onFetchData}
                                >
                                    <GridColumn field="number" title="Invoice Number" filter="numeric" cell={this.InvoiceLinkCell} headerClassName="sortable"/>
                                    <GridColumn field="date" title="Invoice Date" cell={this.DateTimeCell} headerClassName="sortable"/>
                                    <GridColumn field="amount" title="Invoice Total" filter="numeric" format="{0:c2}" headerClassName="sortable"/>
                                </Grid>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="padding-tb10" />
            </div>
        );
    }
}

const AuthenticatedInvoicePage = withAuthenticatedUser(InvoicePage);

export { AuthenticatedInvoicePage as InvoicePage };